import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DownloadMobileAppsComponent } from './download-mobile-apps.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
  ],
  declarations: [DownloadMobileAppsComponent],
  entryComponents: [DownloadMobileAppsComponent]
})
export class DownloadMobileAppsModule { }
